import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectSubscriptionStrategyMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_SUBSCRIPTION_STRATEGY_MESSAGE);
        this.TradingSystemID = null;
        this.StrategySubscriptionStatus = null;
    }
}
